


































































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { KodyCV } from '@/modules/ciselnik/koncernove/kodyCV';
import { SazbaDph } from '@/modules/ciselnik/firemni/dphsazba';
import { EventBus } from '@/main/eventBus';
import { POLOZKA_STATUS } from '@/modules/servis/zakazka/constants';

import DmsDphCalculator from '#components/dms/dphCalculator/DmsDphCalculator.vue';

import { editMutations } from './store/types';
import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		DmsDphCalculator,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		KodyCVSelect: KodyCV.components.Select,
	},
	data() {
		return {
			POLOZKA_STATUS,
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				cv: `${this.storeUri}/${editMutations.CIZY_VYKONY_CV_SELECT_MAPPER}`,
				nakladoveStredisko: `${this.storeUri}/${editMutations.CIZY_VYKONY_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		strednaklOznFilter() {
			return { ProvozovnaId: this.ProvozovnaId, disabledProvozovna: true };
		},
		cvFilter() {
			return {
				ExtkodNr: this.CvNr,
				OstatnizakazkyPrp: !this.IsGaranceOrKulance,
				PaPrp: null,
				VyrobekvozOzn: this.VyrobekvozOzn,
			};
		},
		dphSazba() {
			return (this.SazbyDph && this.DphSzbOzn) ? this.SazbyDph[this.DphSzbOzn].DphSzb : 0;
		},
	},
	async created() {
		await this.getDphSazby();
	},
	methods: {
		async onDiscountChange() {
			let errormsg = null;
			if (this.loggedUser.DiscountLimitConfigData === null) {
				this.Sleva = null;
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			}
			if ((this.Sleva !== null && this.Sleva !== undefined) && this.Sleva > 0 && this.Sleva > (this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer === null ? 0 : this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer)) {
				this.Sleva = null;
				errormsg = this.LocalizeAndReplace(this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer'), { key: '<DISC_PER>', value: `${this.loggedUser.DiscountLimitConfigData.LaborItemTotalPer}%` });
			}
			if ((this.Sleva !== null && this.Sleva !== undefined) && this.Sleva > 0 && this.Sleva > (this.loggedUser.DiscountLimitConfigData.LaborItemPer === null ? 0 : this.loggedUser.DiscountLimitConfigData.LaborItemPer)) {
				this.Sleva = null;
				errormsg = this.LocalizeAndReplace(this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer'), { key: '<DISC_PER>', value: `${this.loggedUser.DiscountLimitConfigData.LaborItemPer}%` });
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					title: '',
					message: `${errormsg}${this.LocalizePopisostatni('LABOR_ITEM').toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return null;
		},
			async loadedData() {
			if (this.props.saga2Status) {
				EventBus.$emit('DisableAll', true);
			}
			if (this.props.saga2Status === POLOZKA_STATUS.ZAMITNUTO) {
				this.operations = 4;
			}
			if (this.props.saga2Status === POLOZKA_STATUS.NAVRH) {
				this.UpravaS2 = true;
				this.CvNr = this.props.polozkaNr;
				this.Text = this.props.polozkaText;
				this.Nc = this.props.dNc;
				this.Pc = this.props.dNc;
				this.NavrhPolId = this.props.polozkaId;
			}
		},
		async getDphSazby() {
			if (this.SazbyDph !== null) return;
			try {
				const result = await SazbaDph.apiProvider.tableData();
				const sazby: any = {};
				_.forEach(result.data, (dataRow) => {
					sazby[dataRow.Cells[1]] = { // DphSzbOzn
						DphSzb: dataRow.Cells[3],
					};
				});
				this.SazbyDph = sazby;
			} catch (err) {
				this.showNotification({ title: err.name, message: err.message });
			}
		},
	},
	watch: {
		Nc(newVal) {
			if (newVal > 0 && this.edit.Gst! > 0) {
				this.edit.NcWithGst = (newVal + (newVal * (this.edit.Gst! / 100)));
			} else { this.edit.NcWithGst = 0; }
		},
		Pc(newVal) {
			if (newVal > 0 && this.edit.Gst! > 0) {
				this.edit.PcWithGst = (newVal + (newVal * (this.edit.Gst! / 100)));
			} else { this.edit.PcWithGst = 0; }
		},
		Gst(newVal) {
			if (newVal > 0) {
				this.edit.NcWithGst = this.edit.Nc! + (this.edit.Nc! * (newVal / 100));
				this.edit.PcWithGst = this.edit.Pc! + (this.edit.Pc! * (newVal / 100));
			}
		},
		Sleva(newVal) {
			if (newVal > 0) {
				this.edit.Pc = this.edit.Pc! - (this.edit.Pc! * (newVal / 100));
				this.edit.PcWithGst = this.edit.Pc! + (this.edit.Pc! * (newVal / 100));
			}
		},
	},
});
